import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface NoPathsDialogProps {
  open: boolean;
  onClose: () => void;
}

const NoPathsDialog = ({ open, onClose }: NoPathsDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Path required</DialogTitle>
      <DialogContent>You don't have any paths yet. Open the Path Builder page and create a path first.</DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoPathsDialog;
